// extracted by mini-css-extract-plugin
module.exports = {"root":"collapsible_root__qwE6_"};